export const servicesToDisplayDurationConfig: Set<string> = new Set(['skipass', 'materiel'])